import axios, { AxiosResponse } from 'axios';
import { loginData } from '../types/interfaces';

const apiUrls = {
  login: '/v1/login',
};

export const login = async (loginData: loginData) => {
  try {
    const response: AxiosResponse = await axios.post(apiUrls.login, {
      email: loginData.user,
      password: loginData.password,
    });
    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      return {
        success: false,
        message: error.response?.data?.message || 'An error occurred',
        status: error.response?.status,
      };
    } else {
      return {
        success: false,
        message: 'An unexpected error occurred',
      };
    }
  }
};

export const confirmUser = async (userId: string, password: string, confirmPassword:string) => {
  try {
    const response: AxiosResponse = await axios.patch(`${apiUrls.login}/users/${userId}`, {
      "password":password,
      "confirmPassword":confirmPassword,
    });
    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      return {
        success: false,
        message: error.response?.data?.message || 'An error occurred',
        status: error.response?.status,
      };
    } else {
      return {
        success: false,
        message: 'An unexpected error occurred',
      };
    }
  }
}

export const getUserToConfirmation = async (id: string) => {
  try {
    const response: AxiosResponse = await axios.get(apiUrls.login+`/users/${id}`);
    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      return {
        success: false,
        message: error.response?.data?.message || 'An error occurred',
        code: error.response?.data?.code,
        status: error.response?.status,
      };
    } else {
      return {
        success: false,
        message: 'An unexpected error occurred',
      };
    }
  }
}

export const requestPasswordRecovery = async (email: string) => {
  try {
    const response: AxiosResponse = await axios.post(`${apiUrls.login}/password-recovery`, {
      email,
    });
    return {
      success: true,
      status: response.status,
    };
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      return {
        success: false,
        message: error.response?.data?.message || 'Ocurrió un error',
        code: error.response?.data?.code,
        status: error.response?.status,
      };
    } else {
      return {
        success: false,
        message: 'Ocurrió un error inesperado',
      };
    }
  }
};

export const validatePasswordResetToken = async (token: string) => {
  try {
    const response: AxiosResponse = await axios.get(`${apiUrls.login}/password-recovery/${token}`);
    return {
      success: true,
      status: response.status,
      email: response.data?.email as string | undefined,
    };
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      return {
        success: false,
        message: error.response?.data?.message || 'Token inválido',
        code: error.response?.data?.code,
        status: error.response?.status,
      };
    } else {
      return {
        success: false,
        message: 'Ocurrió un error inesperado',
      };
    }
  }
};

export const resetPassword = async (token: string, password: string, confirmPassword: string) => {
  try {
    const response: AxiosResponse = await axios.patch(`${apiUrls.login}/password-recovery/${token}`, {
      password,
      confirmPassword,
    });
    return {
      success: true,
      status: response.status,
    };
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      return {
        success: false,
        message: error.response?.data?.message || 'Ocurrió un error',
        code: error.response?.data?.code,
        status: error.response?.status,
      };
    } else {
      return {
        success: false,
        message: 'Ocurrió un error inesperado',
      };
    }
  }
};
